import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../_shared/tooltip/Tooltip';
import { PromotionCard } from './PromotionCard';
import { usePromotion } from './PromotionContext';

export function Promotions(): JSX.Element {
  const { t } = useTranslation(['translation']);
  const { gameId, groupedPromotions } = usePromotion();

  return (
    groupedPromotions.length > 0 && (
      <section className='promotions-wrap'>
        {groupedPromotions.map((gamePromos) => (
          <div key={`promotion-game-${gamePromos.requiredGameId}`}>
            <div className='subtitle'>
              <h3 className='cross-progression-title'>
                {t(
                  'translation:account.my-account.rewards',
                  { requiredGame: t(`games.${gamePromos.requiredGameId}`) },
                )}
              </h3>
              <Tooltip
                id={gamePromos.requiredGameId}
                message='tooltip.rewards'
                options={{ requiredGame: t(`games.${gamePromos.requiredGameId}`), rewardGame: t(`games.${gameId}`) }}
              />
            </div>
            {gamePromos.promotions.map((promo) => (
              <PromotionCard
                key={`promotion-item-${promo.promotionData.promotionId}`}
                promotion={promo}
              />
            ))}
          </div>
        ))}
      </section>
    )
  );
}
